import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../../components/navigation/AuthenticationStateManager";
import AdminSidebar from "../../components/admin/AdminSidebar";
import AdminHeader from "../../components/admin/AdminHeader";

const AdminLayout = () => {
  const { user } = useAuth();

  // 🔒 HARD PROTECTION
  if (!user || user.role !== "ADMIN") {
    return <Navigate to="/authentication-portal" replace />;
  }

  return (
    <div className="min-h-screen bg-background flex">
      {/* Sidebar */}
      <AdminSidebar />

      {/* Right Section */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <AdminHeader />

        {/* Page Content */}
        <main className="flex-1 p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
